module.exports = __webpack_public_path__ + "img/engine_fuel_consumpution_per_mile.12271f4b.svg";